import { type UpdateResolver } from "@urql/exchange-graphcache";

import { type DeleteUserNotificationsInput } from "@/gql/graphql";

type Args = {
  input: DeleteUserNotificationsInput;
};

const updater: UpdateResolver<null, Args> = (_result, args, cache) => {
  for (const id of args.input.notificationIds) {
    if (id) {
      cache.invalidate({
        __typename: "UserNotification",
        id,
      });
    }
  }
};

export const deleteUserNotifications = updater as unknown as UpdateResolver;
